import { DeliveryAddressViewModel } from 'src/app/business/order/delivery-address-viewmodel';

export function compareDeliveryAddresses(
  changedAddress: DeliveryAddressViewModel,
  originalAddress: DeliveryAddressViewModel
): boolean {
  return changedAddress && originalAddress
    ? (originalAddress.name === changedAddress.name || !changedAddress.name) &&
        (originalAddress.address === changedAddress.address || !changedAddress.address) &&
        (originalAddress.additionalAddress === changedAddress.additionalAddress || !changedAddress.additionalAddress) &&
        (originalAddress.city === changedAddress.city || !changedAddress.city) &&
        (originalAddress.postalCode === changedAddress.postalCode || !changedAddress.postalCode)
    : false;
}
